// extracted by mini-css-extract-plugin
export default {"Tabs":"Tabs_Tabs__YE+a7","Tabs__buttons":"Tabs_Tabs__buttons__ULijL","Item":"Tabs_Item__MhUy3","TextWrap":"Tabs_TextWrap__NIRwZ","Item__active":"Tabs_Item__active__CpwaA"};